import { FC, useState } from 'react'

import { MenuOption } from '@joor/design-system'
import DatePicker from 'react-rainbow-components/components/DatePicker'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { GenericFunction } from 'types'

import { getDisplayLanguage } from 'store/currentUser/selectors'

const DatePickerStyled = styled(DatePicker)`
  label {
    font-size: inherit;
    line-height: inherit;
    cursor: pointer;

    & + div {
      display: none;
    }
  }
`

export enum DatePickerType {
  Single = 'single',
  Range = 'range',
}

type FilterProps = {
  type?: DatePickerType
  onChange: GenericFunction
}

export const DatePickerFilter: FC<FilterProps> = ({
  type = DatePickerType.Single,
  onChange,
}) => {
  const [value, setValue] = useState<Date | Date[]>()
  const { displayLanguage } = useSelector((state) => ({
    displayLanguage: getDisplayLanguage(state),
  }))
  const isRange = type === DatePickerType.Range
  const label = isRange ? 'Custom Range' : 'Specific Date'

  const handleChange = (newValue: Date | Date[]): void => {
    onChange(newValue)
    setValue(
      Array.isArray(newValue) && newValue.length === 2 ? undefined : newValue,
    )
  }

  return (
    <MenuOption>
      <DatePickerStyled
        id="ag-grid-filters-date-picker"
        label={label}
        placeholder={label}
        selectionType={type}
        formatStyle="large"
        variant={isRange ? 'double' : 'single'}
        value={value}
        locale={displayLanguage}
        onChange={handleChange}
      />
    </MenuOption>
  )
}
